import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const CodeField = ({ errors, row, onChange }) => {
  const { code } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.code;

  return (
    <div>
      <TextField
        value={code}
        onChange={(_, value) => onChange(value.replace(/[^A-Z0-9]/gi, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.code} />}
    </div>
  );
};

export default observer(CodeField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/code.js